import { render, staticRenderFns } from "./ChatbotStats.vue?vue&type=template&id=e1f9bde0&scoped=true&"
import script from "./ChatbotStats.vue?vue&type=script&lang=js&"
export * from "./ChatbotStats.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotStats.vue?vue&type=style&index=0&id=e1f9bde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f9bde0",
  null
  
)

export default component.exports